import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { NotificationList } from '../../components/Notifications';
import { Button } from '../../components/ui/button';
import { RefreshCw } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL + '/api' });
api.interceptors.request.use(cfg => {
  const t = localStorage.getItem('fb_access_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const StaffNotificationsPage = () => {
  const { user } = useAuth();
  const [generating, setGenerating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      const res = await api.post('/notifications/generate');
      toast.success(`Generated ${res.data.generated} notifications`);
      setRefreshKey(k => k + 1);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error generating notifications');
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="notifications-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-zinc-100">
            {user?.role === 'ADMIN' ? 'System Notifications' : 'Notifications'}
          </h1>
          <p className="text-sm text-zinc-500 mt-1">
            {user?.role === 'ADMIN'
              ? 'User management and system events'
              : 'Team summaries and compliance alerts'}
          </p>
        </div>
        {user?.role !== 'ATHLETE' && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleGenerate}
            disabled={generating}
            className="border-zinc-700 text-zinc-400 hover:text-amber-400 hover:border-amber-500/50"
            data-testid="generate-notifications-btn"
          >
            <RefreshCw className={`w-3.5 h-3.5 mr-1.5 ${generating ? 'animate-spin' : ''}`} />
            {generating ? 'Generating...' : 'Check now'}
          </Button>
        )}
      </div>

      <NotificationList key={refreshKey} />
    </div>
  );
};

export default StaffNotificationsPage;
